<script>
    import FriendStatus from './FriendStatus.svelte';
	import ProfileImage from './ProfileImage.svelte';
	import { user } from '../stores';
    import { db } from '../firebase';
    
    export let friend;
    export let type;  // 'friend', 'incoming', 'outgoing'  TODO: enum

    export let onAccept = () => {};
    export let onCancel = () => {};

    // TODO: make this work
	// TODO: rename this so it makes it clearer that these are just UI flags to
	//       represent whether real names should take priority over the activity
	//       for content overflow.
	// let showRealNames = friends.map(_ => false);
	// TODO: make status use ellipsis if interface is small enough that it's clipping the display name
</script>

<style>
	.friend-row {
		margin: 10px 0;
		display: flex;
		flex-direction: row;
		align-items: stretch;
		letter-spacing: 0.5px;
		font-size: 0.95em;
		font-weight: 500;
		
		/* TODO: color this according to status? */
		background-color: #f6f6f6;
		border-radius: 4px;
		padding: 7px;
		
		/*border: 3px solid #f0f0f0;*/
	}
	.friend-row .profile-image {
		flex: none;
		margin-right: 7px;
	}
	.friend-row .names {
		display: inline-flex;
		align-items: center;
		overflow: hidden;
	}
	.friend-row .display-name {
		padding: 3px;
	}
	.friend-row .real-name {
		padding: 3px;
		color: #bbb;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	/* .friend-row .status-container {
		padding: 3px;
		flex: 1;
		overflow: hidden;
    } */
    
    .friend-row .right {
        padding: 3px;
        flex: 1;
        overflow: hidden;

		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
        justify-content: flex-end;
    }

    button {
        -webkit-appearance: none;
        margin: 3px;
        /* padding: 4px 12px; */
        height: 28px;
        min-width: 64px;

        flex: 0;
        border: none;
        /* border: 1px solid black; */
        border-radius: 5px;

        background-color: transparent;
        color: #222;
        font-size: 0.8em;
    }
    button:hover {
        background-color: #777;
        color: white;
        transition: 0.3s ease-out;
    }
    button:active {
        background-color: #444;
        color: #ddd;
        transition: 0.15s; 
    }

    button.accept {
        color: rgb(80, 197, 119);
    }
    button.accept:hover {
        background-color: rgb(80, 197, 119);
        color: white;  /* if !important set under button:hover this wouldn't be necessary...  evil? */
    }
    button.accept:active {
        background-color: rgb(42, 104, 62);
        color: #ddd;
        transition: 0.15s; 
    }

    button.ignore {
        color: rgb(224, 68, 68);
    }
    button.ignore:hover {
        background-color: rgb(224, 68, 68);
        color: white;  /* if !important set under button:hover this wouldn't be necessary...  evil? */
    }
    button.ignore:active {
        background-color: rgb(163, 59, 59);
        color: #ddd;
        transition: 0.15s; 
    }
</style>

<div class="friend-row">
    <div class="profile-image"><ProfileImage user={friend}/></div>
    <div class="names"
        on:mouseenter={() => {
        // TODO: factor this out
        // See: https://svelte.dev/tutorial/classes for how to do this with classes instead
            // showRealNames = [...showRealNames.slice(0, i), true, ...showRealNames.slice(i+1, showRealNames.length)];
        }}
        on:mouseleave={() => {
            // showRealNames = [...showRealNames.slice(0, i), false, ...showRealNames.slice(i+1, showRealNames.length)];
        }}>
        <span class="display-name">{friend.displayName}</span>
        <!-- <small class="real-name">({friend.realName})</small> -->
    </div>
    <div class="right">
        {#if type === 'friend'}
            <!-- <div class="status-container" 
                style="overflow: {showRealNames[i] ? 'hidden' : 'visible'};"
            >
                <FriendStatus status={friend.status} />
            </div> -->
        {:else if type === 'incoming'}<!---->
            <button class="accept" on:click={onAccept}>Accept</button>
            <!-- <button class="ignore">Ignore</button> -->
        {:else if type === 'outgoing'}<!---->
            <button class="cancel" on:click={onCancel}>Cancel</button>
        {/if}
    </div>
</div>